import {
  FaqContent
} from '../models';

import {
  mapRelationships
 } from './common-mapper';

const mapFaqs = (obj, included) => {
  const item = obj;

  return item.data.flatMap((rel) => {
    return included.flatMap((meta) => {

      if (rel.id === meta.id) {
        return {
          id: meta.id,
          type: meta.type,
          header: meta.attributes?.field_header,
          content: meta.attributes?.field_content?.value
        };
      }
      return [];
    });
  });
};

export const mapFaqContent = (result) => {

  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          faqItems: mapFaqs(item.relationships.field_faq_item, result.included),
          id: item.id,
          relationships: mapRelationships(item.relationships, result.included)
        }
      };
    })
    .map((content) => {
      return new FaqContent(content).mapToStandard();
    });
};